<div
  class="h5p-player"
  [ngClass]="{ 'course-completed': isCompletedCourse() }"
  [class.mobile]="mobileQuery.matches"
>
  <app-h5p-player-header
    #runnerHeader
    [courseTitle]="course()?.name || ''"
    [hasNext]="hasNext || adminPreview()"
    [hasPrevious]="hasPrevious || adminPreview()"
    [isLastActivity]="isLastActivity"
    [adminPreview]="adminPreview()"
    [isPreview]="isPreview"
    [courseId]="courseId"
    [learningPathId]="learningPathId"
    [showCourseNavigation]="showCourseNavigation"
    [isSkippable]="isCurrentActivitySkippable"
    (previous)="previous()"
    (next)="next()"
    (skip)="skip()"
  >
  </app-h5p-player-header>
  @if (displayTimer) {
    <app-h5p-player-timer-component
      [durationInMinutes]="durationInMinutes"
      (timerZero)="timerZero()"
    >
    </app-h5p-player-timer-component>
  }
  <div class="h5p-player-body" [class.collapsed]="sidebarCollapsed()">
    <div class="h5p-player-content">
      <div
        class="h5p-player-container"
        ngClass.gt-md="medium-screen"
        ngClass.gt-lg="large-screen"
      >
        @if (displaySpinner && !globalSpinnerVisible()) {
          <mat-spinner></mat-spinner>
        }
        <div
          #h5pContent
          class="h5p-content notranslate"
          translate="no"
          [class.d-hide]="displaySpinner"
        ></div>
        @if (mobileQuery.matches) {
          <div
            [class.hide]="!showIcon"
            id="h5p-scroll-fade-footer"
            class="h5p-scroll-fade-footer"
          >
            <div class="h5p-scroll-indicator" (click)="scrollToBottom()">
              <mat-icon class="h5p-scroll-indicator-icon size-sm"
                >keyboard_double_arrow_down</mat-icon
              >
            </div>
            @if (showFade) {
              <div class="h5p-container-fade"></div>
            }
          </div>
        }
      </div>
    </div>
    @if (!mobileQuery.matches) {
      <aside class="h5p-player-sidebar">
        <app-course-navigation-panel
          [(collapsed)]="sidebarCollapsed"
          [sections]="course()?.courseActivitiesSections || []"
          [userLanguage]="navLanguage()"
          [translationFields]="navTranslationFields()"
          [currentActivityId]="currentActivityId"
          [answers]="courseActivitiesAnswers"
          [freeOrder]="freeOrder()"
          [isCompletedCourse]="isCompletedCourse()"
          (navigateToActivity)="onSidebarNavigate($event)"
        ></app-course-navigation-panel>
      </aside>
    }
  </div>
  @if (
    mobileQuery.matches && (showCourseNavigation || isCurrentActivitySkippable)
  ) {
    <app-h5p-player-footer
      [showCourseNavigation]="showCourseNavigation"
      [hasNext]="hasNext"
      [hasPrevious]="hasPrevious"
      [isLastActivity]="isLastActivity"
      [isSkippable]="isCurrentActivitySkippable"
      (previous)="previous()"
      (next)="next()"
      (skip)="skip()"
    >
    </app-h5p-player-footer>
  }
</div>
